import React from 'react';
import { useVideos } from '../../hooks/useVideos';
import './VideosPage.css';

const VideosPage = () => {
    const { videos, isLoading } = useVideos();

    const readableDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('de', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        });
    };
    return (
        <div className="video-page">
            <div className='header-banner'>
                <h1>VIDEOS</h1>
            </div>
        {isLoading ? <p>Loading videos...</p> : (
            <div className="video-page__container">
                {videos.map(video => (
                    <a key={video.video_id} className="video-page__video" href={video.video_url} target="_blank" rel="noreferrer">
                        <img
                            title={video.title}
                            src={video.thumbnails.medium}
                            alt="Video Thumbnail"
                        />
                        <div className="video-page__video-content">
                            <p>{video.title}</p>
                            <span>{readableDate(video.published_at)}</span>
                        </div>
                    </a>
                ))}
            </div>
        )}
        </div>
    );
}

export default VideosPage;
